import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { getDynamicTextsEventProperties } from 'helpers/getDynamicTextsEventProperties'
import { getDynamicTextsFromSearch } from 'helpers/getDynamicTextsFromSearch'

import type { TDynamicTextsEventProperties } from 'models/events.model'

import { useExperimentalFeatures } from './useExperimentalFeatures'

type TDynamicTexts = {
  firstPageTitle: string
  firstPageSubtitle: string
  planName: string
  eventProperties: TDynamicTextsEventProperties
}

export const useDynamicTextsFromUrl = (): TDynamicTexts => {
  const { search } = useLocation()
  const { ayah84DynamicHeadlinesTest: canShowDynamicTexts } =
    useExperimentalFeatures()

  const dynamicTexts = useMemo(
    () => getDynamicTextsFromSearch(search),
    [search],
  )

  const eventProperties = getDynamicTextsEventProperties(
    dynamicTexts,
    canShowDynamicTexts,
  )

  const visibleTexts = canShowDynamicTexts
    ? {
        firstPageTitle: dynamicTexts.headline.text,
        firstPageSubtitle: dynamicTexts.subtext.text,
        planName: dynamicTexts.plan.text,
      }
    : {
        firstPageTitle: '',
        firstPageSubtitle: '',
        planName: '',
      }

  return {
    ...visibleTexts,
    eventProperties,
  }
}
